import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
export var getConverter = function getConverter(_ref) {
  var navigateToUrl = _ref.navigateToUrl;
  return function (props) {
    var _props$onClose;
    var getOnSelect = function getOnSelect(bankName, url) {
      return function () {
        var handler = props.handlePayProcess;
        if (!handler) throw new Error("No handler provided for ".concat(bankName));
        handler();
        if (!url) throw new Error('No bank url provided');
        navigateToUrl(url);
      };
    };
    return _objectSpread(_objectSpread({}, props), {}, {
      onClose: (_props$onClose = props.onClose) !== null && _props$onClose !== void 0 ? _props$onClose : function () {
        console.warn('No close handler provided');
      },
      items: props.bankList.map(function (bank) {
        return {
          link: bank.dboLink,
          src: bank.logoURL,
          text: bank.bankName,
          onClick: getOnSelect(bank.bankName, bank.dboLink)
        };
      }),
      onSelect: getOnSelect('', ''),
      inputHandler: props.inputHandler,
      search: props.search
    });
  };
};